import {
  buildAdditionalContactCard,
  type ContactCardOverrides,
} from './additionalContactCard';

export const lenderContactCard = buildAdditionalContactCard({
  contactType: 'lender',
  contactLabel: 'Lender',
  overrides: {
    hideByDefault: false,
    fields: {
      role: {
        label: 'Role',
        placeholderText: 'Loan Officer, Assistant, etc',
      },
    },
  } satisfies ContactCardOverrides,
});
